module.exports = __webpack_public_path__ + "img/mars.b1761e7d.png";